export interface ListState {
  filter: string;
  sortColumn: string;
  sortDirection: string;
  page: number;
  pageSize: number;
  fromDate?: string | null;
  toDate?: string | null;
}

/**
 * Remembers a log page's filters (search, sort, page, date range) while the
 * user opens a record and comes back.
 *
 * It lives in memory only (not localStorage/sessionStorage), so a page refresh,
 * closing the tab, or signing out always starts from the defaults.
 */
export class ListStateMemory {
  private static states = new Map<string, ListState>();

  static save(key: string, state: ListState): void {
    ListStateMemory.states.set(key, { ...state });
  }

  static load(key: string): ListState | null {
    const s = ListStateMemory.states.get(key);
    return s ? { ...s } : null;
  }

  static clearAll(): void {
    ListStateMemory.states.clear();
  }
}
